import { CurrencyEnum, FormSelect } from '@systemeio/ui'
import { usePhysicalProductsList } from 'modules/funnels/funnel/components/step-configuration-tab/physical-product-selector/hooks/use-physical-products-list'
import { getProductListData } from 'modules/funnels/funnel/utils/offer-configuration-utils'
import ItemSteps from 'modules/stores/store/components/item-steps'
import React, { Dispatch, SetStateAction } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { PhysicalProductItemEditType } from '../../types/product-interface'

interface PhysicalProductProps {
  tempState: PhysicalProductItemEditType
  setTempState: Dispatch<SetStateAction<PhysicalProductItemEditType>>
  currency: CurrencyEnum
  physicalProductSelectorError?: string
}

const PhysicalProduct = ({
  tempState,
  setTempState,
  currency,
  physicalProductSelectorError,
}: PhysicalProductProps) => {
  const { t } = useLocoTranslation()

  const { physicalProductsList, isLoading } = usePhysicalProductsList(currency)

  const onChangePhysicalProduct = (value?: number) => {
    if (!value) return

    setTempState(prevState => ({
      ...prevState,
      checkoutPage: { ...prevState.checkoutPage, physicalProductId: value },
    }))
  }

  return (
    <ItemSteps
      steps={[
        {
          key: 'physicalProductSelect',
          title: t('dashboard.store.item.physical_product.title'),
          element: (
            <FormSelect
              isPreFetching={isLoading}
              value={tempState.checkoutPage.physicalProductId}
              data={physicalProductsList && getProductListData(physicalProductsList)}
              onChange={onChangePhysicalProduct}
              error={physicalProductSelectorError}
              withoutCloseIcon
            />
          ),
        },
      ]}
    />
  )
}

export default PhysicalProduct
